import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export const useNotFound = () => {
  const router = useRouter();
  const [query, setQuery] = useState("");
  const [redirectSeconds, setRedirectSeconds] = useState(5);

  useEffect(() => {
    if (redirectSeconds <= 0) {
      router.push("/");
      return;
    }
    const id = window.setTimeout(() => {
      setRedirectSeconds((s) => s - 1);
    }, 1000);
    return () => window.clearTimeout(id);
  }, [redirectSeconds, router]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      router.push(`/search?q=${encodeURIComponent(query.trim())}`);
    }
  };

  return { router, query, setQuery, redirectSeconds, handleSearch };
};
